/*
 * ドラック管理用mixin
 */
<script>
export default {
	props:{
		r_is_resize_max_height: {
			default: true
		},
	},
	/**
	 * @member
	 * @instance
	 * @prop {number} m_dragID - ダイアログID
	 * @prop {number} m_wxy - ダイアログ座標データ
	 **/
	data: function (){
		return {
			m_dragID: "",
			m_dragIDBody: "div.body-container",//! ドラッグアイテム内のコンテンツ表示部セレクタ ※リサイズが必要な場合はここをリサイズする
			m_wxy: { x: 0, y: 0 },
			m_key: 'labelplus_modal_position',
		}
	},
	mounted: function () {
		this.$nextTick(function () {
			// 初期位置設定
			this.onResizeWindow();
			// ダイアログ調整用座標解除
			sessionStorage.removeItem(this.m_key);
			// 表示調整
			this.resizeAdjustModal(true, true);
		});
		$('.more-detail').draggable({handle: '.modal-header', 
										containment: '.modal-mask',
										stop:function(){
											// ダイアログ調整用座標解除
											sessionStorage.removeItem(this.m_key);
											// ドラッグ終了イベント
											this.onDragEnd();
										}.bind(this)
									});
		// ブラウザウィンドウリサイズのイベントリスナーを登録
		window.addEventListener('resize', this.onDragEnd);
	},
	beforeDestroy: function() {
		// ブラウザウィンドウリサイズのイベントリスナーを削除
		window.removeEventListener('resize', this.onDragEnd);
	},
	destroyed: function() {
		var target = $('.modal-container');
		var count = target.length;
		if (count == 0) {
			// 全てのモーダルがなくなったらhtmlの高さを初期化
			$('html').css('height', '');
		} else {
			// モーダルが残っている場合はhtmlの高さを調整
			var top = target[count-1].offsetTop;
			var hight = target[count-1].offsetHeight;
			$('html').css('height', (top+hight));

			// ダイアログ調整用座標解除
			sessionStorage.removeItem(this.m_key);
			// 表示調整
			this.resizeAdjustModal(true, true);
		}
	},
	computed: {
		// ソートID getter 関数
		mixDisp_getSortID: function () {
		  return this.mixM_SortID
		}
	},
	methods: {
		/**
		 * ドラッグ終了イベント
		 */
		onDragEnd:function(){
			console.log("onDragEnd");
			let target = $('.more-detail');
			let pos = target.offset();
			let offsetTop = target[0].offsetTop;//現在のスクロール位置を基準にした上端
			let offsetHeight = target[0].offsetHeight;
			let windowHeight = $(window).outerHeight();

			let childTarget;
			let childPos;
			let childElement;
			let childElementTop;
			if (target.length>1) {
				// 上に重なっている＆ドラッグされたダイアログのoffsetを取得
				childTarget = target.find('.ui-draggable-dragging');
				childPos = childTarget.offset();
				if (childTarget && !childPos) {
					// jQueryで要素が取得できない場合はDOM要素を取得
					childElement = target[target.length-1];
					childElementTop = (childElement.style.top == "") ? 0 : parseFloat(childElement.style.top);
				}
			}

			if(pos.top<0 && windowHeight > offsetHeight
				|| offsetTop < 0 && windowHeight <= offsetHeight ){
				// 詳細のドラッグ部分が画面外に移動していると動かせなくなるので、最上部に移動させる。
				
				if(windowHeight > offsetHeight){
					pos.top = (pos.top<0) ? 0 : window.scrollY;
				}else{
					pos.top = (window.scrollY<0) ? 0 : window.scrollY;
				}
				target.offset(pos);
				
				// 操作ボタンを囲っているブロック位置は常に固定
				$('.more-detail .ui-draggable').css({'top':0, 'left':0});

			} else if (childTarget && childPos && ((childPos.top-window.scrollY) < 0)){
				// ダイアログから開かれるダイアログがスクロール位置より上にある場合は調整する
				childPos.top = window.scrollY;
				childTarget.offset(childPos);
			} else if (childElement && childElementTop <= 0 && childElement.classList.contains("modal-container")){
				childElement.style.top = 0;
			}

			// htmlの高さを変更する(プルダウンを開く方向対策)
			var htmlHight = offsetTop + offsetHeight;
			$('html').css('height', htmlHight);

			// 表示調整
			this.resizeAdjustModal(false, false);
		},
		/**
 		 * ウィンドウリサイズイベント
		 */
		onResizeWindow: function(){
			var obj = $('#' + this.m_dragID);
			var body = $('#' + this.m_dragID + " "+ this.m_dragIDBody);

			var margin = 5;

			var w = obj.width();
			// var h = obj.height(); 現在の高さはあてにならない
			let h=0;
			if ( this.r_is_resize_max_height ) {
				// リストの高さが決まっていない場合
				// 最大高さを基準にする
				var tmp = obj.css("max-height");
				if(tmp != "none")
				{
					if(typeof(tmp) == 'string'){
						tmp = tmp.replace("px","");
						h = parseInt(tmp);
					}
				}
				if(h == 0){
					const MAX_HEIGHT=744;
					h = MAX_HEIGHT;
					if(obj.height() > MAX_HEIGHT){
						h = obj.height()
					}
				}
			} else {
				// リストの高さが初めから決まっている場合
				h = obj.height();
			}
			var scW = $(window).innerWidth();
			var scH = $(window).outerHeight();
			var top=0;
			var left=0;

			if(w>scW || h>scH){
				// max-height の調整が必要
				if(w<scW){
					left = (scW-w)/2;
				}else{
					left =margin;
				}
				
				if(h<scH){
					top = (scH-h)/2;
				}else{
					top=margin;
					/* TODO:max-height を調整するならここで行う */
				}
				
			}else{
				left = (scW-w)/2;
				top = (scH-h)/2;
			}

			let temp=null;
			if(temp = obj.parent()){
				let offset = temp.offset();
				if(offset){
					top -= offset.top;
					left -= offset.left;
				}
			}


			top += $(window).scrollTop();
			left += $(window).scrollLeft();

			var wxy = { x: left, y: top };
			this.m_wxy = wxy;
			obj.css({top: top , left: left});

			// htmlの高さを変更する(プルダウンを開く方向対策)
			var htmlHight = top + h;
			$('html').css('height', htmlHight);

		},

		/**
		 * ドラックイベント <br>
		 * ******* 内部処理 *******<br>
		 * ドラックされた際TOPとleftを変更する。 <br>
		 *
		 * @function  onDragStart
		 * @param {object} e - イベントオブジェクト
		 * @instance
		 */
		onDragStart: function(e){
			// 使用しない
			/*
			var mx = e.pageX;
			var my = e.pageY;
			var wxy = this.m_wxy;
			var dragID = this.m_dragID;

			wxy.x =  $('#' + this.m_dragID)[0].offsetLeft;
			wxy.y =  $('#' + this.m_dragID)[0].offsetTop;

			var maxMx = $(window).innerWidth() -  $('#' + this.m_dragID).width();
			var maxMy = $(window).outerHeight() -  $('#' + this.m_dragID).height();
			
			$(document).on('mousemove.detail-view', function(e) {

				wxy.x = wxy.x + e.pageX - mx;
				wxy.x = wxy.x >= maxMx ? maxMx : wxy.x;
				wxy.x = wxy.x <= 0 ? 0 : wxy.x;

				wxy.y = wxy.y + e.pageY - my;
				wxy.y = wxy.y >= maxMy ? maxMy : wxy.y;
				wxy.y = wxy.y <= 0 ? 0 : wxy.y;
				$('#' + dragID).css({top: wxy.y, left: wxy.x});
				mx = e.pageX;
				my = e.pageY;
				return false;
			}).one('mouseup', function(e) {
				$(document).off('mousemove.detail-view');
			});
			return false;*/
		},
		/**
		 * リサイズ時ダイアログ位置調整
		 * 
		 * sessionStorage.getItem(this.m_key) 
		 * > 設定あり: 画面リサイズ
		 * > 設定なし: ダイアログ移動(draggable) or 閉じる(destroyed)
		 * 
		 * isCalcVertical: 縦計算
		 * isCalcHorizontal: 横計算
		 */
		resizeAdjustModal: function(isCalcVertical = false, isCalcHorizontal = false) {
			// ダイアログ取得
			let target = $('.modal-mask-content > .modal-wrapper > .more-detail');
			// ダイアログ存在
			if (target.length > 0) {
				// 画面サイズ
				// let windowWidth = window.outerWidth;
				let windowWidth = window.innerWidth;
				let windowHeight = window.innerHeight;
				// let windowWidth = document.body.clientWidth;
				// 調整スペース(リサイズ微調整用)
				let spaceWidth = 50;
				let spaceHeight = 20;
				// ダイアログ調整用座標存在判定
				let isBackUpAdjustPos = false;
				let arrBackUpAdjustPos = {};
				let sessionModalPos = sessionStorage.getItem(this.m_key);
				if (sessionModalPos) {
					isBackUpAdjustPos = true;
					arrBackUpAdjustPos = JSON.parse(sessionModalPos);
				}
				// 表示中の最前面ダイアログ取得
				let adjustTarget = (target.length > 1 && target[target.length-1].id) ? $('#' + target[target.length-1].id + '.more-detail') : target;
				// ダイアログ要素
				let adjustElement = target[target.length-1];
				// ダイアログサイズ
				let adjustDialogWidth = adjustElement.offsetWidth;
				let adjustDialogHeight = adjustElement.offsetHeight;
				// ダイアログ座標
				let adjustPos = (isBackUpAdjustPos) ? arrBackUpAdjustPos : adjustTarget.offset();

				// ダイアログ調整計算判定
				var isCalcAdjustVer = (isBackUpAdjustPos || isCalcVertical) ? true : false;
				var isCalcAdjustHor = (isBackUpAdjustPos || isCalcHorizontal) ? true : false;
				
				// リサイズ横調整
				var posLeft = 0;
				if (isCalcAdjustHor) {
					// 画面サイズ < (ダイアログサイズ + オフセット)
					if (windowWidth < (adjustDialogWidth + adjustPos.left)) {
						posLeft = windowWidth - adjustDialogWidth - spaceWidth;
						if (windowWidth > adjustDialogWidth) {
							adjustPos.left = (posLeft > 0) ? posLeft : 0;
						} else {
							adjustPos.left = 0;
						}
					// 画面サイズ >= (ダイアログサイズ + オフセット)
					} else {
						posLeft = windowWidth - adjustDialogWidth;
						adjustPos.left = (adjustPos.left < 0) ? posLeft : adjustPos.left;
					}
				}
				
				// リサイズ縦調整
				var posTop = 0;
				if (isCalcAdjustVer) {
					var calcTop = adjustTarget.offset().top - document.body.scrollTop;
					var calcDialogHeight = calcTop + adjustDialogHeight + spaceHeight;
					if (windowHeight < calcDialogHeight) {
						if (windowHeight > adjustDialogHeight) {
							if (windowHeight < (adjustDialogHeight + spaceHeight)) calcDialogHeight = calcDialogHeight - spaceHeight;
							var calcHeight = calcDialogHeight - windowHeight;
							posTop = adjustTarget.offset().top - calcHeight;
							adjustPos.top = (posTop > 0) ? posTop : document.body.scrollTop;
						} else {
							adjustPos.top = document.body.scrollTop;
						}
					} else {
						adjustPos.top = adjustTarget.offset().top;
					}
				}

				// 座標設定
				adjustTarget.offset(adjustPos);

				// ダイアログ調整用座標設定
				sessionStorage.setItem(this.m_key, JSON.stringify(adjustPos));
			}
		},
	},
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/common/DragItem.mixin.vue